export enum SpatemCrudTypeEnum {
  UPDATE_SPATEM_RSUS = 'updateSpatemRsus',
}

export type SpatemCrudType = {
  id: string;
  onClose: () => void;
  onGoingBack: () => void;
  closeDialog: () => void;
};

export type SpatemRsusManageType = {
  id: string;
  closeDialog: () => void;
};
